import { apiRequests } from '../utilities/axios-factory'
import store from '../store'
import { generateKeywordsQueryForOr } from '@smarttransit/common'

function getTransactions (agentProfileId, {
  dateFrom,
  dateTo,
  keywords,
  logTypes,
  orderBy = 'dateUpdated',
  sortOrder = 'DESC',
  page = 1,
  limit = 10
}) {
  const where = { agentProfileId }

  if (dateFrom) {
    where.dateUpdated = {
      gte: new Date(dateFrom).toISOString()
    }
  }

  if (dateTo) {
    where.dateUpdated = Object.assign({}, where.dateUpdated, {
      lte: new Date(dateTo).toISOString()
    })
  }

  if (logTypes && logTypes.length) {
    where.logType = { inq: logTypes }
  }

  const filter = {
    where: where,
    limit: limit,
    offset: page === 1 ? 0 : (page * limit) - limit,
    include: 'agentMobileMoneyAccount'
  }

  if (keywords && keywords.trim()) {
    const keywordOrQueries = generateKeywordsQueryForOr(keywords, [])

    filter.join = {
      relation: 'agentMobileMoneyAccount',
      scope: { where: keywordOrQueries }
    }
  }

  if (orderBy) {
    filter.order = `${orderBy} ${sortOrder || 'DESC'}`
  }

  return apiRequests.get('/v1/agent-transaction-log/join/', {
    params: { filter },
    headers: {
      Authorization: store.getters.tokenId
    }
  }).then((result) => {
    return result.data
  })
}

function getTotalTransactions (agentProfileId, {
  dateFrom,
  dateTo,
  keywords,
  logTypes
}) {
  const where = {}

  if (dateFrom) {
    where.dateUpdated = {
      gte: new Date(dateFrom).toISOString()
    }
  }

  if (dateTo) {
    where.dateUpdated = {
      ...where.dateUpdated,
      lte: new Date(dateTo).toISOString()
    }
  }

  if (logTypes?.length) {
    where.logType = { inq: logTypes }
  }

  let join

  if (keywords && keywords.trim()) {
    const keywordOrQueries = generateKeywordsQueryForOr(keywords, [])

    join = {
      relation: 'agentMobileMoneyAccount',
      scope: { where: keywordOrQueries }
    }
  }

  where.agentProfileId = agentProfileId

  return apiRequests.get('/v1/agent-transaction-log/count/join/', {
    params: { where, join },
    headers: {
      Authorization: store.getters.tokenId
    }
  }).then((result) => {
    return result.data?.count
  })
}

function getCreditPeriodTotals (agentProfileId, { dateFrom, dateTo }) {
  return apiRequests.get(`/v1/agent-profile/${agentProfileId}/credit-period-totals/`, {
    params: { dateFrom, dateTo },
    headers: {
      Authorization: store.getters.tokenId
    }
  }).then((result) => {
    return result.data
  })
}

export {
  getTransactions,
  getTotalTransactions,
  getCreditPeriodTotals
}
